import { type FC } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';

import { type ProfitDropRewardType } from '../../config';

import ProfitDropRewardCard from './ProfitDropRewardCard';

interface ProfitDropRewardFlipCardProps {
  status: 'hidden' | 'revealed-nonreward' | 'revealed-reward';
  type: ProfitDropRewardType;
  value: number;
  onFinish?: () => void;
  onClick?: () => void;
  layoutId?: string;
  delay?: number;
  size: 'sm' | 'lg';
  noBorder?: boolean;
}

const ProfitDropRewardFlipCard: FC<ProfitDropRewardFlipCardProps> = ({
  status,
  type,
  value,
  onFinish,
  onClick,
  layoutId,
  delay,
  size,
  noBorder,
}) => {
  const isRevealed =
    status === 'revealed-reward' || status === 'revealed-nonreward';

  return (
    <motion.div
      layoutId={layoutId}
      className="aspect-square"
      style={{ perspective: '1000px' }}
      onClick={isRevealed ? undefined : onClick}
    >
      <motion.div
        className="relative size-full"
        initial={{ rotateY: isRevealed ? 180 : 0 }}
        animate={{ rotateY: isRevealed ? 180 : 0 }}
        transition={{ duration: 0.45, ease: 'easeInOut', delay }}
        onAnimationComplete={
          status === 'revealed-reward' ? onFinish : undefined
        }
        style={{ transformStyle: 'preserve-3d' }}
      >
        <div
          className="rounded-xl absolute inset-0 flex items-center justify-center from-[#8352BD] to-[#47198C] bg-gradient-to-b shadow-glass-blur"
          style={{
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
          }}
        >
          <span className="text-[2.5rem] font-bold text-white/40">?</span>
        </div>

        <div
          className={cn(
            'rounded-xl absolute inset-0 overflow-hidden',
            status === 'revealed-nonreward' && 'grayscale',
            status === 'revealed-reward' &&
              !noBorder &&
              'border-2 border-white shadow-[0px_0px_8px_rgb(255,255,255),_0px_0px_5px_rgba(255,255,255,0.8)_inset]',
          )}
          style={{
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            transform: 'rotateY(180deg)',
          }}
        >
          <ProfitDropRewardCard
            type={type}
            value={value}
            size={size}
            className="!bg-black/60"
          />
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ProfitDropRewardFlipCard;
